import { request } from '@luna/api';
import { getEnv } from '@luna/env';

export enum CURRENCY_FLAG {
    PROVIDED = 'provided',
    TRADING_PROHIBITED = 'tradingProhibited',
    INTERNATIONAL_PAYMENT_ALLOWED = 'internationalPaymentAllowed',
    INTRA_BANK_PAYMENT_ALLOWED = 'intraBankPaymentAllowed',
    CROSS_CURRENCY_PAYMENT_NOT_ALLOWED = 'crossCurrencyPaymentNotAllowed',
    BANK_GUARANTEE_ALLOWED = 'bankGuaranteeAllowed',
}

interface ExchangeRate {
    buy: number;
    middle?: number;
    sell: number;
    lastModified: string;
}

export interface Currency {
    currency: string;
    precision: number;
    rateUnit: number;
    nameI18N: string;
    flags: CURRENCY_FLAG[];
    exchangeRate: ExchangeRate;
}

export interface CurrenciesPayload {
    baseCurrency?: string;
    lastUpdated?: string;
    instituteId?: number;
    fx: Currency[];
}

function getUrlVersion1(): string {
    return getEnv().prestoUrl.replace('v2', 'v1').replace('v3', 'v1');
}

export function fetchCurrencies(): Promise<CurrenciesPayload> {
    const url = `${getUrlVersion1()}info/fx?size=999`;

    return request<CurrenciesPayload>(url);
}
